import React, { useState } from "react";
import { BookOpen, ChevronDown, UserCheck, Users } from "lucide-react";
import { FieldError } from "./TeacherMocksShared";
import PublicationExtraStudentsCard from "./PublicationExtraStudentsCard";
import PublicationSpecificStudentsPanel from "./PublicationSpecificStudentsPanel";
import StudentListModal from "./StudentListModal";

export default function PublicationSettingsSection({
  values,
  errors,
  showError,
  errorId,
  isSubmitting,
  publicationLevels,
  isLoadingPublicationLevels,
  courseStudentsCount,
  onAvailabilityModeChange,
  onAddStudent,
  onRemoveStudent,
  onUpdateStudents,
  onTriggerLevelChange,
  onToggleNotify,
}) {
  const [isListOpen, setIsListOpen] = useState(false);
  const selectedStudentsCount = values.studentIds.length;
  const selectedLevel = publicationLevels.find((level) => String(level.id) === String(values.triggerLevelId));
  const allStudentsLabel = courseStudentsCount == null ? "Todos do curso" : `Todos do curso (${courseStudentsCount})`;
  const summaryValue = values.availabilityMode === "all"
    ? (courseStudentsCount == null ? selectedStudentsCount : courseStudentsCount + selectedStudentsCount)
    : selectedStudentsCount;

  const modes = [
    {
      key: "all",
      label: allStudentsLabel,
      icon: Users,
    },
    {
      key: "specific",
      label: "Alunos específicos do curso",
      icon: UserCheck,
    },
    {
      key: "module_completion",
      label: "Ao completar módulo",
      icon: BookOpen,
    },
  ];

  return (
    <section className="teacher-mocks-publication-section">
      <div className="teacher-mocks-publication-section-title">
        <h3>Seleção de alunos</h3>
        <p>Defina a base de alunos e como este simulado será disponibilizado.</p>
      </div>

      <div className="teacher-mocks-publication-modes">
        <span>Como disponibilizar este simulado</span>
        <div>
          {modes.map((mode) => {
            const Icon = mode.icon;
            const active = values.availabilityMode === mode.key;
            return (
              <button
                key={mode.key}
                type="button"
                className={active ? "active" : ""}
                onClick={() => onAvailabilityModeChange(mode.key)}
                disabled={isSubmitting}
              >
                <Icon size={16} aria-hidden="true" />
                {mode.label}
              </button>
            );
          })}
        </div>
      </div>

      {values.availabilityMode === "all" && (
        <PublicationExtraStudentsCard
          values={values}
          isSubmitting={isSubmitting}
          onAddStudent={onAddStudent}
          onRemoveStudent={onRemoveStudent}
        />
      )}

      {values.availabilityMode === "specific" && (
        <PublicationSpecificStudentsPanel
          values={values}
          isSubmitting={isSubmitting}
          onAddStudent={onAddStudent}
          onUpdateStudents={onUpdateStudents}
        />
      )}

      {values.availabilityMode === "module_completion" && (
        <div className="teacher-mocks-publication-trigger">
          <strong>Módulo gatilho</strong>
          <p>Qualquer aluno que concluir o módulo escolhido receberá este simulado automaticamente.</p>
          <label>
            <select
              value={values.triggerLevelId}
              onChange={(event) => onTriggerLevelChange(event.target.value)}
              disabled={isSubmitting || isLoadingPublicationLevels || !values.courseId}
              aria-invalid={!!showError("triggerLevelId")}
              aria-describedby={showError("triggerLevelId") ? errorId("triggerLevelId") : undefined}
            >
              <option value="">
                {isLoadingPublicationLevels ? "Carregando módulos..." : "Selecione um módulo..."}
              </option>
              {publicationLevels.map((level) => (
                <option key={level.id} value={level.id}>{level.name}</option>
              ))}
            </select>
            <ChevronDown size={14} aria-hidden="true" />
          </label>
          {selectedLevel && <p>O simulado será liberado quando o aluno concluir {selectedLevel.name}.</p>}
          {showError("triggerLevelId") && <FieldError id={errorId("triggerLevelId")}>{errors.triggerLevelId}</FieldError>}
        </div>
      )}

      {values.availabilityMode !== "module_completion" && (
        <>
          <div className="teacher-mocks-publication-selected-summary">
            <span>Alunos selecionados</span>
            <strong>{summaryValue}</strong>
            {values.availabilityMode === "specific" && selectedStudentsCount > 0 && (
              <button type="button" onClick={() => setIsListOpen(true)}>
                Ver lista
              </button>
            )}
          </div>
          {showError("studentIds") && <FieldError id={errorId("studentIds")}>{errors.studentIds}</FieldError>}
        </>
      )}

      <div className="teacher-mocks-publication-notify">
        <button
          type="button"
          className={values.notifyStudents ? "active" : ""}
          onClick={onToggleNotify}
          disabled={isSubmitting}
          aria-pressed={values.notifyStudents}
          aria-label="Mandar notificação"
        >
          <div />
        </button>
        <div>
          <p>Mandar notificação</p>
          <p>Dispara uma notificação para os alunos selecionados quando o simulado for publicado.</p>
        </div>
      </div>

      {isListOpen && (
        <StudentListModal
          studentIds={values.studentIds}
          studentNames={values.studentNames}
          onConfirm={onUpdateStudents}
          onClose={() => setIsListOpen(false)}
        />
      )}
    </section>
  );
}
